import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import ClaimStatusChip from '@/parcels/components/ClaimStatusChip/ClaimStatusChip'

import * as Styles from './styles'

const ParcelCardClaim = ({ status }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      <Styles.FullWidthDivider />
      <Styles.Footer>
        <Text type="bodyMRegular" color={theme.colors.text.default}>
          {t('Claim')}
        </Text>
        <ClaimStatusChip status={status} />
      </Styles.Footer>
    </>
  )
}

export default ParcelCardClaim
